@if (showCommonItems$ | async) {
  <div class="row">
    <div class="col-12">
      <mat-card class="p-3">
        <div class="items-bar">
          <mat-form-field appearance="outline" class="search-input" subscriptSizing="dynamic">
            <mat-label>Search items...</mat-label>
            <input matInput [ngModel]="searchTerm" (ngModelChange)="onSearchTermChange($event)"/>
          </mat-form-field>
          <div class="filters">
            @for (f of [{label: 'All', key: 'ALL'}, {label: 'Item Group', key: 'ITEM_GROUPING'}, {label: 'Item', key: 'ITEM'}, {label: 'Modifier Group', key: 'MODIFIER_GROUPING'}, {label: 'Modifier', key: 'MODIFIER'}]; track f) {
              <button
                (click)="setFilter($any(f.key))"
                [class.active]="filter === f.key"
                >
                {{ f.label }}
              </button>
            }
          </div>
          @if (sortColumn) {
            <button
              class="reset-sort-btn"
              (click)="resetSorting()"
              matTooltip="Reset to default sorting"
              >
              <mat-icon>clear</mat-icon>
              Reset Sort
            </button>
          }
          <div class="right">
            @if (!(hideButtonsToggle$ | async) && isSuperAdmin) {
                <button mat-raised-button matTooltip="Import an existing item group, item, modifier group, or modifier from Management"
                        (click)="openImportLegacyItemDialog()">
                    <mat-icon style="color: white">add</mat-icon>
                    Import
                </button>
                <button mat-raised-button matTooltip="Create a new item group, item, modifier group, or modifier"
                (click)="openCreateCommonItemDialog()">
                <mat-icon style="color: white">add</mat-icon>
                Create Common Item
              </button>
            }
          </div>
        </div>
        @if (isLoading) {
          <div class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="loading-text">Loading common items...</p>
          </div>
        }
        @if (!isLoading) {
          <div class="table-container">
            <table class="items-table">
              <thead>
                <tr>
                  <th>Image</th>
                  <th class="sortable-header" (click)="sortByColumn('tag')">
                    ID/Tag
                    @if (sortColumn === 'tag') {
                      <mat-icon class="sort-icon">
                        {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                      </mat-icon>
                    }
                  </th>
                  <th class="sortable-header" (click)="sortByColumn('name')">
                    Name
                    @if (sortColumn === 'name') {
                      <mat-icon class="sort-icon">
                        {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                      </mat-icon>
                    }
                  </th>
                  <th class="sortable-header" (click)="sortByColumn('class')">
                    Class
                    @if (sortColumn === 'class') {
                      <mat-icon class="sort-icon">
                        {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                      </mat-icon>
                    }
                  </th>
                  <th class="sortable-header" (click)="sortByColumn('type')">
                    Type
                    @if (sortColumn === 'type') {
                      <mat-icon class="sort-icon">
                        {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                      </mat-icon>
                    }
                  </th>
                  <th class="sortable-header" (click)="sortByColumn('migrated')">
                    Fully Migrated
                    @if (sortColumn === 'migrated') {
                      <mat-icon class="sort-icon">
                        {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                      </mat-icon>
                    }
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (item of (filteredItems$ | async); track trackByTag($index, item)) {
                  <tr (click)="goToDetail(item)" style="cursor: pointer">
                    <td class="image-col">
                      @if (item.image) {
                        <img [src]="item.image" alt="{{item.name}}" class="item-image"/>
                      } @else {
                        <img width="37px" height="37px" alt="No Image"
                          src="https://d4gii57lvoht3.cloudfront.net/images/CFA_Circle_Logo.png">
                        }
                      </td>
                      <td class="tag-column" [matTooltip]="item.tag" matTooltipPosition="above">{{ item.tag }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.class ?? item.objectType }}</td>
                      <td>{{ item.type }}</td>
                      <td>{{ item.migrated }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </mat-card>
      </div>
      <emm-help-button></emm-help-button>
    </div>
  }
